export const container = () => ({
    width: '100%',
    maxWidth: '28.75rem',

    position: 'relative',
    zIndex: 1,

    tabletLarge: {
        marginTop: -180,
        marginBottom: 30,
    },
});

export const image = () => ({
    boxShadow: `0px 6px 30px 0px rgba(0, 0, 255, 0.35)`,
});
